export function isUnderBreakpoint(current, breakpoints) {
  return breakpoints.some((breakpoint) => breakpoint === current);
}

function isInRange(breakpoints) {
  return (current) => {
    return breakpoints.some((breakpoint) => breakpoint === current);
  };
}

export const isMobileBreakpoint = isInRange([`watch`, `phone`, `phablet`]);
export const isTabletBreakpoint = isInRange([`tablet`]);
export const isDesktopBreakpoint = isInRange([`desktop`, `wide`]);
